import { render, staticRenderFns } from "./prices.vue?vue&type=template&id=8b5e8dce&scoped=true&"
import script from "./prices.vue?vue&type=script&lang=js&"
export * from "./prices.vue?vue&type=script&lang=js&"
import style0 from "./prices.vue?vue&type=style&index=0&id=8b5e8dce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5e8dce",
  null
  
)

export default component.exports